import React from "react";

import { clsx } from "clsx";
import { Loading } from "ui-svgs";

type Props = {
  containedOverlay?: boolean;
  className?: string;
  fill?: string;
};

const Tabledataloading = ({ containedOverlay, className, fill }: Props) => (
  <>
    <div
      className={clsx({
        "table-data-loader": true,
        [`${className ? className : ""}`]: className,
      })}
    >
      <div className="table-data-loading">
        <Loading fill={fill} />
      </div>

      {containedOverlay && <div className="overlay" />}
    </div>
  </>
);

export default Tabledataloading;
